import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { cloneDeep } from 'lodash';
import { sortBy } from 'lodash';
import moment from 'moment';
import { withRouter } from "react-router";
import { CardPageLayout } from "component-lib/CardPageLayout";
import { mapCompanySelector } from "store/state/auth";
import { AccordionEditSection } from "component-lib/AccordionSection";
import { updateHedge, hedgeDetailGetHedge, hedgeDetailGetDealMetrics, hedgeDetailGetDealProperties } from './hedgeDetail.store';
import { DEAL_METRICS } from '@loanbossinc/component-library';
import { HEDGE_SECTION_KEY } from "./hedge.constants";
import { GenericHeroCard } from "component-lib/";
import { rows as financialRows } from './hedge-financials/section-hedge-financials-edit-rows';
import { rows as generalInfoRows } from './hedge-general-information/section-general-information-edit-rows';
import { rows as hedgeRatingsRows } from './hedge-ratings/section-hedge-ratings-edit-rows';
import { ToastError } from "../../components/Global/Toasts/Toasty";

const dealMetrics = [
  DEAL_METRICS.CLOSING_DATE
  , DEAL_METRICS.PURCHASE_PRICE
  , DEAL_METRICS.SQUARE_FEET
];

class HedgeSectionEdit extends Component {
  state = {
    isSaving: false,
    isCanceling: false,
  }

  componentDidMount() {
    document.getElementById('ScrollToNav').scrollIntoView({ behavior: 'smooth' });
    const { hedgeId } = this.props.match.params;
    // NOTE: Handles the scenario that the store is not loaded when you come to this page. ex: refresh page.
    const { hedge } = this.props;
    if (!hedge) {
      this.props.hedgeDetailGetHedge({ hedgeId });
      this.props.hedgeDetailGetDealProperties({ hedgeId });
    }
  }

  modifyValuesForSerialization = (details) => {
    details.dealId = details.dealId;
    details.markToMarket = null;
    details.marketCost = null;
    details.marketRate = null;
    details.isLenderRequired = details.isLenderRequired;

    details.cap = details.cap ? details.cap / 100 : null;
    details.floor = details.floor ? details.floor / 100 : null;
    details.lowerStrike = details.lowerStrike ? details.lowerStrike / 100 : null;
    details.rate = details.rate ? details.rate / 100 : null;
    details.spread = details.spread ? details.spread / 100 : null;
    details.upperStrike = details.upperStrike ? details.upperStrike / 100 : null;
    details.strike = details.strike ? details.strike / 100 : null;
    details.creditCharge = details.creditCharge ? details.creditCharge / 10000 : null;



    delete details.deal;
    delete details.fund;
    delete details.ancillary;
    return details;
  }

  redirectToDetails = () => {
    const { history, newHedgeId } = this.props;
    if (newHedgeId) {
      history.replace(`/hedges/${newHedgeId}`);
    }
  };

  onSubmit = (hedge) => {
    if (!this.validateHedge(hedge)) {
      this.setState({ isEditing: false });
    } else {
      const { sectionName, dealId } = this.props.match.params;
      let hedgeDetailsRequest = {}
      if (sectionName === HEDGE_SECTION_KEY.NEW_HEDGE) {
        this.props.hedgeDetailCreateHedge({ dealId, hedge, callback: this.redirectToDetails })
      } else {
        hedgeDetailsRequest.id = hedge.id;
        hedgeDetailsRequest.isNew = hedge.id === "new";
        const clonedValues = cloneDeep(hedge);
        hedgeDetailsRequest.hedge = this.modifyValuesForSerialization(clonedValues);
        hedgeDetailsRequest.callback = () => { this.setState({ isSaving: false }) }
        this.setState({ isEditing: false });
        this.props.updateHedge(hedgeDetailsRequest);
      }
    }
  }

  validateHedge = (hedge) => {
    let hasErrors = false;
    if (
      hedge.terminationDate &&
      (
        (hedge.tradeDate && moment(hedge.terminationDate).isBefore(hedge.tradeDate))
        ||
        (hedge.effectiveDate && moment(hedge.terminationDate).isBefore(hedge.effectiveDate))
      )
    ) {
      ToastError('Termination date can not be sooner than the Trade or Effective date');
      hasErrors = true;
    }
    return !hasErrors;
  }

  startSave = () => {
    this.setState({ isSaving: true })
  }
  startCancel = () => {
    this.setState({ isCanceling: true })
  }

  finishSave = () => {
    this.setState({ isSaving: false, isCanceling: false })
  }

  renderBody = () => {
    const { sectionName } = this.props.match.params;
    const { hedge } = this.props;

    if (!hedge) return null;

    let sectionRows = null;

    const configItems = {
      dealLoans: sortBy(hedge.ancillary.dealLoans, "name"),
      companiesByTypeId: sortBy(hedge.ancillary.companiesByTypeId, "name"),
      floatingIndexes: hedge.ancillary.floatingIndexes,
      ...hedge.ancillary.companyCreditRatings.ancillary
    };

    switch (sectionName) {
      case HEDGE_SECTION_KEY.FINANCIALS:
        sectionRows = financialRows;
        break;
      case HEDGE_SECTION_KEY.GENERAL_INFORMATION:
        sectionRows = generalInfoRows;
        hedge.taggedTo = !hedge.loanId ? true : false;
        break;
      case HEDGE_SECTION_KEY.RATING:
        sectionRows = hedgeRatingsRows;
        break;
      default:
        sectionRows = null;
        break;
    }
    if (!sectionRows)
      return null;

    return (<AccordionEditSection
      rows={sectionRows}
      configItems={configItems}
      finishSave={this.finishSave}
      isSaving={this.state.isSaving}
      isCanceling={this.state.isCanceling}
      data={hedge}
      onSubmit={this.onSubmit}
      onCancel={this.finishSave}
    />);
  }

  render() {
    if (!this.props.hedge || !this.props.dealProperties) return null;
    const title = `${this.props.hedge.hedgeProvider ? this.props.hedge.hedgeProvider.name : "No Provider Selected"} - ${this.props.hedge.hedgeType ? this.props.hedge.hedgeType.value : "No Type Selected"}`;

    return (
      <>
        <CardPageLayout {...this.props}
          isReversed
          bannerImageUrl={this.props.hedge && this.props.hedge.deal && this.props.hedge.deal.imageLarge}
          cardComponent={<GenericHeroCard save={this.startSave} cancel={this.startCancel} {...{ ...this.props, deal: this.props.dealProperties, title: title, backLabel: "Hedge Details" }} />}
          bodyComponent={
            <div className="d-flex f-1 flex-column">
              {this.renderBody()}
            </div>
          }
        />
      </>
    );
  }
}

const mapStateToProps = ({ newHedgeDetail, authentication }) => ({
  ...newHedgeDetail
  , company: mapCompanySelector(authentication)
  , authentication
});

export default compose(
  withRouter
  , connect(mapStateToProps, {
    hedgeDetailGetHedge
    , hedgeDetailGetDealMetrics
    , updateHedge
    , hedgeDetailGetDealProperties
  })
)(HedgeSectionEdit);
